module.exports = __webpack_public_path__ + "images/external_images/svg/mockups/devices-1.svg";